import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  DataTable,
  DataTablePageEvent,
  DataTableRowClickEvent,
} from "primereact/datatable";
import { Column } from "primereact/column";
import {
  formatDateTime,
  parseQueryString,
  toQueryString,
} from "../../common/utils";
import { none } from "../common";
import { useQuery } from "react-query";
import { accountsRequest } from "../../api/queries/account/accounts";
import { queryKeys } from "../../api/query";
import { AccountListItem } from "../../api/types/account";
import { Button } from "primereact/button";

export default function AccountList() {
  const navigate = useNavigate();
  const limit = 20;
  const queryParams = parseQueryString(useLocation().search);

  const [offset, setOffset] = useState(0);
  const [total, setTotal] = useState(0);
  const [sortField, setSortField] = useState(queryParams.sortField);
  const [sortOrder, setSortOrder] = useState(queryParams.sortOrder);

  const onPage = ({ first }: DataTablePageEvent) => setOffset(first);
  const onSort = (event: any) => {
    setSortField(event.sortField);
    setSortOrder(event.sortOrder);
  };

  const { data: accounts, isLoading } = useQuery({
    queryFn: () => accountsRequest({ limit, offset }),
    queryKey: queryKeys.accountListPage({ limit, offset }),
  });

  const onRowClick = (event: DataTableRowClickEvent) =>
    navigate(`/accounts/${event.data.id}`);

  const tName = (row: AccountListItem) => row.name || none;

  const tInstitution = (row: AccountListItem) => row.institution.name || none;

  const tActive = (row: AccountListItem) => (
    <i className={row.active ? "fa fa-check" : "fa fa-times"} />
  );

  const tCreatedAt = (row: AccountListItem) => formatDateTime(row.created_at);

  const tUpdatedAt = (row: AccountListItem) => formatDateTime(row.updated_at);

  useEffect(() => {
    const queryParamsStr = toQueryString({
      limit: 20,
      offset,
      sortField,
      sortOrder,
    });
    navigate({ search: queryParamsStr });
  }, [offset, navigate, sortField, sortOrder]);

  useEffect(() => {
    if (accounts) {
      setTotal(accounts.data.total_count);
    }
  }, [accounts]);

  return (
    <div className={"col-12"}>
      <div className="flex py-3">
        <h1 className="m-0">Account</h1>

        <div className="flex gap-1 ml-auto">
          <Button
            onClick={() => navigate("/accounts/new")}
            className="p-button p-button-main p-button-sm"
            label="Add new"
          />
        </div>
      </div>

      <DataTable
        emptyMessage={"No records"}
        paginator={true}
        lazy={true}
        rows={20}
        first={offset}
        totalRecords={total}
        loading={isLoading}
        sortField={sortField}
        sortOrder={sortOrder}
        onPage={onPage}
        onSort={onSort}
        value={accounts?.data.results || []}
        className="p-datatable-sm p-datatable-pointer"
        onRowClick={onRowClick}
        stripedRows={true}
      >
        <Column header={"Name"} body={tName} />

        <Column header={"Institution"} body={tInstitution} />

        <Column header={"Active"} body={tActive} />

        <Column header={"Created at"} body={tCreatedAt} />

        <Column header={"Updated at"} body={tUpdatedAt} />
      </DataTable>
    </div>
  );
}
